module.exports = __webpack_public_path__ + "img/z_spark.32da559c.jpg";